import {
    About as AboutView,
    AbstractsSubmissionPage as AbstractsSubmissionPageView,
    Committee as CommitteeView,
    Home as HomeView,
    NotFoundCover as NotFoundCoverView,
    PasswordResetCover as PasswordResetCoverView,
    Workshop as WorkshopView,
    SigninCover as SigninCoverView,
    SignupCover as SignupCoverView,
    Gallery as GalleryView,
    Symposium as SymposiumView,
} from 'views/LandingPage';

const routes = [
    {
        path: '/',
        renderer: (params = {}) => <HomeView {...params} />,
    },
    {
        path: '/about',
        renderer: (params = {}) => <AboutView {...params} />,
    },
    {
        path: '/abstract-submission',
        renderer: (params = {}) => <AbstractsSubmissionPageView {...params} />,
    },
    {
        path: '/gallery',
        renderer: (params = {}) => <GalleryView {...params} />,
    },
    {
        path: '/committee',
        renderer: (params = {}) => <CommitteeView {...params} />,
    },
    {
        path: '/workshop',
        renderer: (params = {}) => <WorkshopView {...params} />,
    },
    {
        path: '/symposium',
        renderer: (params = {}) => <SymposiumView {...params} />,
    },
    {
        path: '/forget-password',
        renderer: (params = {}) => <PasswordResetCoverView {...params} />,
    },
    {
        path: '/not-found-cover',
        renderer: (params = {}) => <NotFoundCoverView {...params} />,
    },
    {
        path: '/signin',
        renderer: (params = {}) => <SigninCoverView {...params} />,
    },
    {
        path: '/signup',
        renderer: (params = {}) => <SignupCoverView {...params} />,
    },
];

export default routes;
